import $ from "jquery";

let fs            = require('fs');
const Handlebars  = require("handlebars");

const accessToken = 'pk.eyJ1Ijoib3Zlci1hbmQtYWJvdmUiLCJhIjoiY2tuaDM2OXlxMzJmZTJvcGg0dXVxanJ4diJ9.UCXY8SldhnzIns0tLjQtUw';


window.openBuyModal = function(buyer, bunning_item_number) {


    //console.log("bunning_item_number",bunning_item_number);

    var source     = document.getElementById("buy-template").innerHTML;
    var template   = Handlebars.compile(source);

    document.getElementById('PopupModal').innerHTML = template();
    document.getElementById('PopupModal').classList.add("active");
    document.body.classList.add("lock");

    
    if (buyer && buyer != undefined) {
        $('.buy-modal__types').hide();
        if (buyer == 'Bunnings') {
            $('#hidden_type').val("bunnings");
        }
        if (buyer == 'Independent') {
            $('#hidden_type').val("independent");
        }
    }

 
    if (bunning_item_number && bunning_item_number != undefined) {

        //console.log("SET bunning_item_number",bunning_item_number);

        $('.buy-modal__buy-online').attr("href", "https://www.bunnings.com.au/_p"+bunning_item_number);
    } else {
        $('.buy-modal').addClass("bunnings--inactive");
    }

    setBuyModalEvents();

}




const setBuyModalEvents = function() {

    console.log("setBuyModalEvents");


    $(".buy-modal__close").on("click",function(e) {
        e.preventDefault();
        document.body.classList.remove("lock");
        document.getElementById('PopupModal').innerHTML = "";
        document.getElementById('PopupModal').classList.remove("active");
    });

    $(".buy-modal__mylocation").on("click",findGeoLocation);

    let _filterCheckbox = $('.checkbox input[type=checkbox]');
    _filterCheckbox.on('click',onCheckboxClick);


    initGeocoder();
}

const initGeocoder = function() {


    if ($('#modal-geocoder').length) {
    
        var geocoder = new MapboxGeocoder({
            accessToken: accessToken,
            countries: 'au',
            placeholder: 'Enter your postcode, suburb or state',
            types: 'region,place,postcode,locality,neighborhood'
        });
        
        geocoder.addTo('#modal-geocoder');
        geocoder.on('result', function (e) {
            $(".buy-modal__form input[name='location']").val(e.result.place_name);
            $(".buy-modal__form input[name='bbox0']").val(e.result.bbox[0]);
            $(".buy-modal__form input[name='bbox1']").val(e.result.bbox[1]);
            $(".buy-modal__form input[name='bbox2']").val(e.result.bbox[2]);
            $(".buy-modal__form input[name='bbox3']").val(e.result.bbox[3]); 
            $(".buy-modal__form").trigger("submit");
        });
    }

}


const onCheckboxClick = function(e) {

    e.stopPropagation();



    var independent_check = $('#checkbox_independent').prop("checked");
    var bunnings_check    = $('#checkbox_bunnings').prop("checked");

    if (independent_check && !bunnings_check) {
        $('#hidden_type').val('independent');
    }
    if (bunnings_check && !independent_check) {
        $('#hidden_type').val('bunnings');
    }
    if (bunnings_check && independent_check) {
        $('#hidden_type').val('');
    }

    console.log("onCheckboxClick", independent_check, bunnings_check);


    if (!this.checked) {
      $(this).parent().removeClass("active")
    } else {
      $(this).parent().addClass("active")
    }
    
  }

const findGeoLocation = function(e) {

    e.preventDefault();


    $(".buy-modal__form").addClass("loading");

    if(navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
           getReverseGeocode(position.coords.latitude, position.coords.longitude);
        });
    } else {
        $(".buy-modal__form").addClass("error");
    }
}


const getReverseGeocode = function(lat,lng) {

    var type = $('#hidden_type').val();
    var url = "https://api.mapbox.com/geocoding/v5/mapbox.places/" + lng + "," + lat + ".json?access_token=" + accessToken;
    $.get(url, function(data){
        window.location = "/pages/where-to-buy?type="+type+"&location="+data.features[1].place_name+"&lat=" + data.query[1] + "&long=" + data.query[0];
    });
}



export const initBuyModal = function() {

	console.log("initBuyModal");

};